// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ContactPage_pageWrapper__oFHTk","page":"ContactPage_page__7bzOI","footers":"ContactPage_footers__1P2fe"};